import { GeographicalDistributionAssignment } from "./geographical-assignment";
export default GeographicalDistributionAssignment;
